<template>
  <div class="flex items-center justify-center min-h-screen bg-gradient-to-br from-white to-gray-100 px-4">
    <div class="text-center max-w-md">
      <!-- Reliable hosted image from Vercel -->
      <h1 class="text-6xl font-extrabold text-gray-800 mb-4">
        404
      </h1>
      <p class="text-lg text-gray-600 mb-6">
        The page you are looking for doesn’t exist or has been moved.
      </p>
      <router-link
        to="/"
        class="inline-block  text-black px-6 py-6 rounded-xl text-base hover:bg-gray-800 transition"
      >
        Go Back
      </router-link>
    </div>
  </div>
</template>

<style scoped>
h1{
  font-size: 180px;
  font-weight: 600;
  padding-top: 160px;
}
p{
  font-size: 22px;
}
a{color: blue !important;}
</style>